module.exports = __webpack_public_path__ + "img/moren.3f5ce2ed.png";